/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { PopoverContainer } from '@deprecated-ui/header';
import color from '@deprecated-ui/_style/color';

const ButtonTrading = styled(Flex)<{ minimize?: boolean; isActive?: boolean }>`
  position: relative;
  align-items: center;
  border-left: 1px solid ${color.gainsboro};
  justify-content: ${({ minimize = false }) =>
    minimize ? 'space-between' : 'space-around'};
  flex-direction: ${({ minimize = false }) => (!minimize ? 'column' : 'row')};

  height: ${({ minimize = false }) => (!minimize ? '101px' : '60px')};
  cursor: pointer;

  width: 100%;
  min-width: 110px;
  max-width: 145px;
  padding: 16px;

  ::after {
    content: '';
    position: absolute;
    width: 100%;
    top: 100%;
    right: 0;
    height: 0;
    background: ${color.light};
    z-index: 2;
  }

  img.arrow {
    transform: ${({ isActive }) =>
      isActive ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 0.3s ease;
    user-select: none;
  }
`;

const TextLabel = styled(Text)<{ minimize?: boolean }>`
  font-size: 13px;
  line-height: 18px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  user-select: none;

  max-width: ${({ minimize = false }) => (minimize ? '60px' : '100px')};
  padding-left: ${({ minimize = false }) => (minimize ? '4px' : '0')};
`;

const TradingMenuTitle = styled(Text)`
  padding: 0 15px;
  line-height: 24px;
  font-weight: bold;
  font-size: 14px;
  color: ${color.primary};
`;

const TradingMenuItemContainer = styled.a`
  bakcground: none;
  border: none;
  display: flex;
  align-items: center;
  padding: 8px;
  height: 35px;
  cursor: pointer;

  :hover {
    background: #f7f7f7;
    border-radius: 4px;
  }
`;

const TradeAreaContent = styled.div`
  padding: 8px 8px 0;
  min-width: 250px;
  width: 100%;

  .divider {
    margin: 8px 0 0;
    border-top: 1px solid #f1f1f1;
  }

  :last-child {
    border-bottom: none;
    padding-bottom: 8px;

    .divider,
    a:nth-child(3) {
      display: none;
    }
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-left: 1px solid ${color.downgray};
  border-bottom: 1px solid ${color.downgray};
`;

const PopoverContainerFlex = styled(PopoverContainer)`
  position: absolute;
  top: 100%;
  right: 0;
  display: flex;

  max-height: calc(100vh - 100px);
  overflow-y: auto;

  /* Remove scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Remove scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
`;

const PopoverContainerBlock = styled(PopoverContainerFlex)`
  display: block;
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  border-bottom-left-radius: 4px;

  h1,
  p,
  span,
  img {
    user-select: none;
  }
`;

const NavigationMobile = styled(Flex).attrs({
  direction: 'column',
  py: '15px',
  align: 'center',
  justify: 'center',
})`
  border-top: 1px solid ${color.downgray};
  border-right: 1px solid ${color.downgray};

  @media screen and (max-width: 762px) {
    &:first-child {
      display: none;
    }
  }
`;

export const StockTransferNotif = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})`
  background-color: #ecf8fd;
  min-width: 250px;
  width: 100%;

  button {
    background-color: transparent;
    border: none;
    cursor: pointer;

    &.trading-menu-notification {
      padding: 6px 0 6px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      font-family: var(--bold-font);
      text-align: left;
      color: #333333;

      p {
        margin: 0;
      }

      img {
        margin-right: 12px;
        min-width: 38px;
      }
    }

    &.trading-menu-notification-close {
      padding: 0 12px;

      img {
        min-width: 10px;
      }
    }
  }
`;

export const ButtonBuyWrapper = styled.div`
  padding: 16px;
  min-width: 250px;
  border-bottom: 1px solid #f1f1f1;
`;

export {
  ButtonTrading,
  TextLabel,
  TradingMenuTitle,
  TradingMenuItemContainer,
  TradeAreaContent,
  Grid,
  PopoverContainerBlock,
  NavigationMobile,
};
